// eslint-disable-next-line import/prefer-default-export
export const localMixin = {
  data() {
    return {
      lang: 'he',
      locals: {
        about: { he: 'אודות', en: 'About' },
        actions: { he: 'פעולות', en: 'Actions' },
        add: { he: 'הוספה', en: 'Add' },
        addition: { he: 'הוספה', en: 'Addition' },
        alert_delete: { he: 'שימו לב! אתם עומדים למחוק משהו', en: 'Careful, you are about to delete something' },
        auth: { he: 'אימות', en: 'Authentication' },
        birth_date: { he: 'תאריך לידה', en: 'Birth date' },
        cancel: { he: 'ביטול', en: 'Cancel' },
        confirm: { he: 'מאשר', en: 'Confirm' },
        choice: { he: 'בחירה', en: 'Choice' },
        choose: { he: 'בחר', en: 'Choose' },
        choose_category: { he: 'בחרו קטגוריה', en: 'Choose category' },
        choose_meeting_session: { he: 'בחרו מפגש', en: 'Choose meeting' },
        choose_file: { he: 'בחר קובץ', en: 'Choose File' },
        comments: { he: 'הערות', en: 'Comment' },
        city: { he: 'עיר', en: 'City' },
        date: { he: 'תאריך', en: 'Date' },
        delete: { he: 'מחיקה', en: 'Delete' },
        display: { he: 'תצוגה', en: 'Display' },
        dont_have_account: { he: 'עדיין אין משתמש?', en: 'Don\'t have account ?' },
        main_screen_title: { he: 'מערכת דיווחי נוכחות', en: 'Time Attendance System' },
        email: { he: 'דוא"ל', en: 'Email' },
        end: { he: 'סיום', en: 'End' },
        end_date: { he: 'תאריך סיום', en: 'End date' },
        remove: { he: 'מחיקה', en: 'Remove' },
        error_create: { he: 'ארעה תקלה בעת יצירה של ', en: 'Error occurred while creating' },
        error_update: { he: 'ארעה תקלה בעת עדכון של ', en: 'Error occurred while updating' },
        events: { he: 'אירועים', en: 'Events' },
        exit: { he: 'יציאה', en: 'Exit' },
        expired_date: { he: 'תאריך תוקף', en: 'Expired' },
        firstname: { he: 'שם פרטי', en: 'First Name' },
        forgot: { he: 'שכחתי סיסמה', en: 'Forgot Password' },
        forgot_your_password: { he: 'שכחת את סיסמתך?', en: 'Forgot your Password?' },
        home: { he: 'ראשי', en: 'Home' },
        lastname: { he: 'שם משפחה', en: 'Last Name' },
        location: { he: 'מיקום', en: 'Location' },
        login: { he: 'התחבר', en: 'Login' },
        login_2: { he: 'התחברות', en: 'Login' },
        logout: { he: 'התנתק', en: 'Logout' },
        password: { he: 'סיסמה', en: 'Password' },
        print: { he: 'הדפסה', en: 'Print' },
        profile: { he: 'פרופיל', en: 'Profile' },
        remember_me: { he: 'זכור אותי', en: 'Remember Me' },
        register: { he: 'הרשם', en: 'Register' },
        reset: { he: 'איפוס', en: 'Reset' },
        save: { he: 'שמור', en: 'Save' },
        scan: { he: 'סריקה', en: 'Scan' },
        search: { he: 'חפש', en: 'Search' },
        settings: { he: 'הגדרות', en: 'Settings' },
        sensors: { he: 'חיישנים', en: 'Sensors' },
        sign_in: { he: 'התחבר', en: 'Sign in' },
        sign_up_here: { he: 'הירשם כאן', en: 'Sign up here' },
        start_date: { he: 'תאריך התחלה', en: 'Start Date' },
        street: { he: 'רחוב', en: 'Street' },
        success_create: { he: 'נוצר בהצלחה', en: 'Was successfully created' },
        success_update: { he: 'עודכן בהצלחה', en: 'Was successfully updated' },
        terms: { he: 'תנאי שימוש', en: 'Terms' },
        title: { he: 'אפליקציית TopEdu', en: 'TopEdu App' },
        title_text: { he: 'כותרת', en: 'Title' },
        upload: { he: 'העלאה', en: 'Upload' },
        username: { he: 'שם משתמש', en: 'User name' },
        chose_project_course: { he: 'בחרו פרויקט', en: 'Chose Project/Course' },
        chose: { he: 'בחרו', en: 'Chose' },
        chose_create_meeting: { he: 'כעת בחרו מפגש מתוכנן או צרו חדש', en: 'Now chose scheduled meeting or create new' },
        fill_meeting: { he: 'מלאו מפגש', en: 'Fill meeting' },
        subject: { he: 'נושא שיעור', en: 'Lesson subject' },
        students_presence: { he: 'כמות תלמידים נוכחים', en: 'Amount of tudents presence' },
        confirmation: { he: '* אני מאשר שדיווח זה אמין ומבוצע בעודי נוכח בכיתת ההדרכה', en: 'I confirm that this report is the truth and submitted while attended the class' },
        hour: { he: 'שעה', en: 'Hour' },
        to: { he: 'עד', en: 'To' },
        lecturer_comments: { he: 'הערות מרצה', en: 'Lecturer comments' },
        send: { he: 'שלח', en: 'Send' },
        view: { he: 'צפה', en: 'View' },
        year: { he: 'שנה', en: 'Year' },
        welcome: { he: 'ברוך הבא', en: 'Welcome' },
        peace: { he: 'שלום', en: 'Welcome' },
        new_session: { he: 'מפגש חדש', en: 'New meeting' },
        or: { he: 'או', en: 'or' },
        session_date_validation: { he: 'תאריך מפגש הינו שדה חובה', en: '' },
        session_start_time_validation: { he: 'שעת התחלה הינו שדה חובה', en: '' },
        session_end_time_validation: { he: 'שעת סיום הינו שדה חובה', en: '' },
        invalid_hours_range: { he: 'שעת סיום חייבת להיות גדולה יותר משעת ההתחלה', en: '' },
        errorrs_to_fix: { he: 'אנא תקנו את הבעיות הבאות', en: '' },
        id_card: { he: 'תעודת זהות', en: '' },
        report_students_attendance: { he: 'דווח נוכחות', en: 'Report attendance' },
        students_list: { he: 'רשימת תלמידים', en: 'Students list' },
        empty_students_list: { he: 'אין תלמידים משוייכים', en: '' },
        new: { he: '', en: '' },
      },
    };
  },
  methods: {
    trans(q) {
      if (this.locals[q.toLowerCase()]) {
        return this.locals[q.toLowerCase()][this.lang];
      }
      return '?';
    },
    switchLang() {
      // eslint-disable-next-line no-console
      console.log(this.lang);
      this.lang = this.lang === 'he' ? 'en' : 'he';
      // eslint-disable-next-line no-plusplus
      this.viewCounter++;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/localMixin.js